<template>
  <v-dialog
    v-model="isOpen"
    width="540"
    scrim="white"
    persistent
    class="prompt-modal"
  >
    <v-card rounded="lg">
      <v-card-title>
        <span class="message">{{ data.message }}</span>
        <v-btn
          flat
          append-icon="fa-regular fa-xmark"
          class="editor-btn-text"
          @click="cancel"
        >
          Aizvērt
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="answer"
          :label="data.inputLabel"
          :placeholder="data.inputPlaceholder"
          variant="outlined"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat class="editor-btn-text" @click="cancel">{{ data.cancelLabel }}</v-btn>
        <v-btn flat class="editor-btn" @click="confirm">{{ data.confirmLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
export default {
  setup() {
    const { isOpen, answer, data, confirm, cancel } = usePrompt()

    return { isOpen, answer, data, confirm, cancel }
  }
}
</script>

<style lang="sass" scoped>
.prompt-modal
  backdrop-filter: blur(7px)

  .v-card
    padding: 24px 16px

    .v-card-title
      display: flex
      justify-content: space-between
      align-items: flex-start
      gap: 8px
      padding: 0
      margin: 0 0 24px 0

      .message
        font-size: 28px

      .modal-close-btn
        position: relative
        margin-top: 0

    .v-card-text
      padding: 0
      margin: 0 0 14px 0

    .v-card-actions
      min-height: unset
      padding: 0
      gap: 8px
</style>
